import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
import * as echarts from 'echarts';

require('echarts/theme/macarons'); // echarts theme


import { debounce } from '@/utils';
import NP from 'number-precision';
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '60vh'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    xAxisData: {
      type: Array,
      required: true
    },
    barData: {
      type: Array,
      required: true
    },
    render: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      chartOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          },
          backgroundColor: 'rgba(80, 80, 80, 0.8)'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {},
        xAxis: [{
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          name: '',
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: []
      },
      chart: null,
      metrics: []
    };
  },
  watch: {
    render: {
      deep: true,
      handler: function handler() {
        this.setOptions(2);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();

    if (this.autoResize) {
      this.__resizeHanlder = debounce(function () {
        if (_this.chart) {
          _this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHanlder);
    } // 监听侧边栏的变化


    var sidebarElm = document.getElementsByClassName('el-aside')[0];
    sidebarElm.addEventListener('transitionend', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHanlder);
    }

    var sidebarElm = document.getElementsByClassName('el-aside')[0];
    sidebarElm.removeEventListener('transitionend', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions(from) {
      var _that = this;

      if (this.barData.length > 0) {
        this.barData.forEach(function (ele) {
          _that.metrics.push(ele.name);
        });
      } // 是否显示汇总


      if (this.showTotal) {
        if (this.barData.length > 0 && (!Object.prototype.hasOwnProperty.call(this.barData[this.barData.length - 1], 'label') || this.barData[this.barData.length - 1].label === {})) {
          this.barData[this.barData.length - 1].label = {
            show: true,
            position: 'top',
            color: '#ff0000',
            formatter: function formatter(params) {
              var total = 0;

              _that.barData.forEach(function (ele) {
                return total = NP.plus(total, ele.data[params.dataIndex]);
              });

              return _that.barData[_that.barData.length - 1]['stack'] !== undefined && _that.barData[_that.barData.length - 1]['stack'] === '2' ? NP.round(NP.divide(total, 10000), 2) : total;
            }
          };
        }
      }

      this.chartOption.xAxis[0].data = this.xAxisData;

      if (this.barData.length > 0 && Object.prototype.hasOwnProperty.call(this.barData[0], 'stack') && this.barData[0]['stack'] === '2') {
        this.chartOption.yAxis[0].name = '万升';

        this.chartOption.yAxis[0].axisLabel.formatter = function (value, index) {
          return NP.divide(value, 10000);
        };

        this.chartOption.tooltip.formatter = function (params, ticket, callback) {
          var showStr = params[0].name + '<br />';
          params.forEach(function (ele) {
            showStr += ele.seriesName + '：<span style="font-weight: bold;margin-left: 10px">' + NP.round(NP.divide(ele.value, 10000), 2) + '万升</span><br />';
          });
          return showStr;
        };
      } else {
        this.chartOption.yAxis[0].name = '升';

        this.chartOption.yAxis[0].axisLabel.formatter = function (value, index) {
          return value;
        };
      }

      this.chartOption.series = this.barData; // console.log('bar', this.chartOption)

      this.chart.setOption(this.chartOption, true);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$el, 'macarons');

      var _that = this;

      this.chart.on('legendselectchanged', function (obj) {
        var b = obj.selected;
        var d = [];

        for (var key in b) {
          if (b[key]) {
            d.push(key);
          }
        }

        var lastName = d.length > 0 ? d[d.length - 1] : '';

        var idx = _that.metrics.indexOf(lastName);

        _that.barData.forEach(function (ele) {
          if (ele.hasOwnProperty('label')) {
            ele.label.show = false;
          }
        });

        var changedBarData = _that.barData; // console.log('cccc', d, b, idx, _that.metrics, lastName, _that.barData)

        if (idx >= 0 && _that.showTotal) {
          _that.barData[idx]['label'] = {
            show: true,
            position: 'top',
            color: '#ff0000',
            formatter: function formatter(params) {
              var total = 0;
              changedBarData.forEach(function (ele) {
                if (d.indexOf(ele.name) >= 0) {
                  return total = NP.plus(total, ele.data[params.dataIndex]);
                }
              });
              return changedBarData[changedBarData.length - 1]['stack'] !== undefined && changedBarData[changedBarData.length - 1]['stack'] === '2' ? NP.round(NP.divide(total, 10000), 2) : total;
            }
          };
        }

        if (_that.barData.length > 0 && Object.prototype.hasOwnProperty.call(_that.barData[0], 'stack') && _that.barData[0]['stack'] === '2') {
          _that.chartOption.yAxis[0].name = '万升';

          _that.chartOption.yAxis[0].axisLabel.formatter = function (value, index) {
            return NP.divide(value, 10000);
          };
        } else {
          _that.chartOption.yAxis[0].name = '升';

          _that.chartOption.yAxis[0].axisLabel.formatter = function (value, index) {
            return value;
          };
        }

        _that.chartOption.series = _that.barData;

        _that.chart.setOption(_that.chartOption);
      });
      this.setOptions(1);
    }
  }
};